// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-tag + .el-tag[data-v-7e7e1b87] {\r\n  margin-left: 10px;\n}\r\n", ""]);
// Exports
module.exports = exports;
